import React from 'react'
import { motion } from 'framer-motion';
import ResumeCard from './ResumeCard';

const Education = () => {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 0.5 } }}
      className="w-full flex flex-col lgl:flex-row gap-10 lgl:gap-20"
    >
      {/* part one */}
      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">1998 - 2010</p>
          <h2 className="text-3xl md:text-4xl font-bold">Education Quality</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Master Of Arts In Human Resources Management"
            subTitle="Kakatiya University Warangal"
            result="3.90/4"
            des="A master's degree is an advanced degree that demonstrates a deep understanding of a specific area of study. It typically requires a bachelor's degree as a prerequisite"
          />
          <ResumeCard
            title="Graduate in Bachelor Of Arts"
            subTitle="Kakatiya university Warangal"
            result="4.75/5"
            des="A graduate is someone who has earned a degree or diploma from a school, such as a college or university."
          />
          <ResumeCard
            title="Secondary School Education"
            subTitle="Begumpet, Hyderabad"
            result="5.00/5"
            des="Secondary education or post-primary education covers two phases on the International Standard Classification of Education scale."
          />
        </div>
      </div>
      {/* part Two */}

      <div>
        <div className="py-6 lgl:py-12 font-titleFont flex flex-col gap-4">
          <p className="text-sm text-designColor tracking-[4px]">2010 - 2022</p>
          <h2 className="text-3xl md:text-4xl font-bold">Job Experience</h2>
        </div>
        <div className="mt-6 lgl:mt-14 w-full h-[1000px] border-l-[6px] border-l-black border-opacity-30 flex flex-col gap-10">
          <ResumeCard
            title="Freelance Digital Marketing Expert"
            subTitle="Self Employed - (2017 - Present)"
            result="USA"
            des="To Handle Multiple Client's Requirements."
          />
          <ResumeCard
            title="Freelance Web Developer & Trainer"
            subTitle="Self Employed- (2012 - 2016)"
            result="USA"
            des="To Handle Multiple Client's Requirements about the Developement and designing."
          />
          <ResumeCard
            title="Freelance Graphics Designer"
            subTitle="Self Employed - (2020 - 2011)"
            result="USA"
            des="To Handle Multiple Client's Requirements about the videos editing and motion graphics"
          />
        </div>
      </div>
    </motion.div>
  );
}

export default Education